export default "__VITE_ASSET__DSjgEVrI__"